/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinalizeGenerationProcedureDto
 */
export interface FinalizeGenerationProcedureDto {
    /**
     * Procedure ID
     * @type {string}
     * @memberof FinalizeGenerationProcedureDto
     */
    procedureId: string;
}

/**
 * Check if a given object implements the FinalizeGenerationProcedureDto interface.
 */
export function instanceOfFinalizeGenerationProcedureDto(value: object): value is FinalizeGenerationProcedureDto {
    if (!('procedureId' in value) || value['procedureId'] === undefined) return false;
    return true;
}

export function FinalizeGenerationProcedureDtoFromJSON(json: any): FinalizeGenerationProcedureDto {
    return FinalizeGenerationProcedureDtoFromJSONTyped(json, false);
}

export function FinalizeGenerationProcedureDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalizeGenerationProcedureDto {
    if (json == null) {
        return json;
    }
    return {
        
        'procedureId': json['procedureId'],
    };
}

export function FinalizeGenerationProcedureDtoToJSON(json: any): FinalizeGenerationProcedureDto {
    return FinalizeGenerationProcedureDtoToJSONTyped(json, false);
}

export function FinalizeGenerationProcedureDtoToJSONTyped(value?: FinalizeGenerationProcedureDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'procedureId': value['procedureId'],
    };
}

